import { SyncRunStatus } from "../services/model/SyncRun";

export const BLOCK_STATUS_TAG: Record<
  "Blocked" | "Unblocked",
  { label: string; variant: "success" | "drafted" | "failed" | "processing" }
> = {
  Blocked: { label: "Blocked", variant: "failed" },
  Unblocked: { label: "Unblocked", variant: "success" },
};

export const CHANNEL_LABELS: Record<string, string> = {
  BATCH: "Scheduled",
  ADHOC: "Adhoc",
};

export const SYNC_STATUS_TAG: Record<
  SyncRunStatus,
  {
    label: string;
    variant: "success" | "drafted" | "failed" | "processing" | "pending";
  }
> = {
  [SyncRunStatus.PENDING]: { label: "Queued", variant: "pending" },
  [SyncRunStatus.STARTED]: { label: "In progress", variant: "processing" },
  [SyncRunStatus.SUCCESS]: { label: "Success", variant: "success" },
  [SyncRunStatus.PARTIAL]: { label: "Partial success", variant: "drafted" },
  [SyncRunStatus.FAILED]: { label: "Failure", variant: "failed" },
};
